// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-footer[data-v-4ef369dc]{background-image:url(/assets/images/footer/bg-footer-mobile.webp)}@media (min-width:1024px){.bg-footer[data-v-4ef369dc]{background-image:url(/assets/images/footer/bg-footer.webp)}}", ""]);
// Exports
module.exports = exports;
